import React from "react";
import { SeoMeta } from "../components/SeoMeta";
import { Card, CardContent } from "../components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { UserRound } from "lucide-react";
import { SITE, ABOUT } from "../mock";

export default function About() {
  return (
    <div className="relative">
      <SeoMeta 
        title="O mně | Zdravé packy Nový Bohumín"
        description="Informace o mé praxi a vzdělání ve fyzioterapii zvířat v Novém Bohumíně. Mám certifikaci CAAPR a zkušenosti z veterinární kliniky."
        url="https://www.zdravepacky.cz/about"
      />
      <section className="pt-10 pb-16">
        <div className="mx-auto max-w-6xl px-4 grid md:grid-cols-2 gap-8 items-center">
          <div className="rounded-2xl overflow-hidden shadow-xl bg-white/10 backdrop-blur-xl border border-white/20 h-[420px] flex items-center justify-center">
            {ABOUT.image ? (
              <img src={ABOUT.image} alt="Jennifer Di Mauro provádí fyzioterapeutické cvičení s kočkou na klinice Zdravé packy" className="w-full h-[420px] object-cover" />
            ) : (
              <div className="flex flex-col items-center justify-center gap-3 p-8 text-center text-muted-foreground w-full h-full bg-muted/20">
                <div className="w-20 h-20 rounded-full bg-white/10 dark:bg-white/5 border border-white/20 flex items-center justify-center text-muted-foreground/70">
                  <UserRound className="w-10 h-10" />
                </div>
                <span className="text-sm font-medium">[Bude doplněna fotografie]</span>
              </div>
            )}
          </div>
          <Card className="bg-white/10 backdrop-blur-xl border-white/20">
            <CardContent className="p-6">
              <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-foreground">
                O mně — {SITE.name}
              </h1>
              <p className="mt-4 text-base leading-relaxed text-foreground/80 whitespace-pre-line">
                {ABOUT.text}
              </p>

              <Accordion type="single" collapsible className="mt-6">
                <AccordionItem value="item-1">
                  <AccordionTrigger>Vzdělání a praxe</AccordionTrigger>
                  <AccordionContent>
                    <ul className="list-disc pl-5 space-y-1 text-sm text-foreground/80">
                      <li>TSOŠ veterinární v Kroměříži (4 roky)</li>
                      <li>Certifikace cert.CAAPR (2023)</li>
                      <li>Veterinární klinika ABVet Bohumín</li>
                    </ul>
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-2">
                  <AccordionTrigger>Co mě motivuje</AccordionTrigger>
                  <AccordionContent>
                    Zdraví a pohoda zvířat jsou pro mě na prvním místě. Každý pacient je jedinečný a zaslouží si
                    citlivý, individuální přístup.
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
}